export const questionsHeadersData = [
  {
    text: 'ID',
    value: 'id'
  },
  {
    text: 'Name',
    value: 'name'
  },
  {
    text: 'Questions Type',
    value: 'type'
  },
  {
    text: 'Summary',
    value: 'summary'
  },
  {
    text: 'Instructions',
    value: 'instructions'
  },
  {
    text: 'Category',
    value: 'practice'
  }
];
